import { emptyClient } from '../../constants/initialStates'
import { ReduxAction } from '../../types/common'
import {
  ADD_CLIENT,
  GET_CLIENT,
  GET_CLIENT_ACCOUNT_TOTAL,
  GET_CLIENT_ROLES,
  GET_CLIENT_PERSON,
  GET_CLIENTS,
  UPDATE_CLIENT,
  VALID_CLIENT,
  GET_CLIENTS_BEFORE,
  GET_CLIENTS_AFTER,
  GET_CLIENT_DEALS,
  GET_CLIENT_CASHFLOWS,
  GET_CLIENT_DEALS_ERROR,
  GET_CLIENT_CASHFLOWS_ERROR,
  GET_CLIENT_TAX_POSITION,
  GET_CLIENT_TAX_POSITION_ERROR,
  GET_CLIENT_TAX_SUMMARY,
  GET_CLIENT_TAX_SUMMARY_ERROR,
  GET_POSITION_BUYS,
  CLEAR_VALID_CLIENT,
} from '../actionTypes'
import { Position } from './portfolio'

interface Adress {
  addressId?: number | null | undefined
  addressType?: string | null | undefined
  country?: string | null | undefined
  street?: string | null | undefined
  town?: string | null | undefined
  zipCode?: string | null | undefined
}

export interface ClientPortfolioType {
  name: string
  portfolioId: number | null
  amount: number | null
  currency: string
  type: string
  amountHistory: []
  assetClassPosition: [] 
  currencyPosition: []
  instrumentPosition: []
  riskPosition: []
  horizontePosition: []
  externalId: string | null
  accountsBalance: number | null
  riskValue: number | null
  horizonteValue: number | null
  buys: BuyPositions[]
}

export interface BuyPositions {
  positionId: number
  buys: Position[]
}

export interface Contract {
  contractId: number | null
  uid: string | null
  contractType: string | null
  contractDate: Date | string | null
}

export interface Client {
  birthDate: Date | string | null
  birthPlace: string | null
  clientCounterpartyId: string | null
  clientId: number
  portfolios: ClientPortfolioType[]
  contactAddress: Adress | null
  contactAddressEqualsPermanent: boolean
  counterpartyName: string | null
  email: string | null
  firstName: string | null
  identityCardIssuer: string | null
  identityCardNumber: string | null
  identityCardValidity: Date | string | null
  investmentHorizonte: string | null
  investmentQuestionnaireValidTo: Date | null | string
  note: string | null
  permanentAddress: Adress
  personalNumber: string | null
  riskProfile: number | null
  esg: string | null
  state: string | null
  surname: string | null
  telephoneNumber: string | null
  titleAfter: string | null
  titlePre: string | null
  contracts: Contract[]
  nationality: string | null
  roles: string[]
  category: string | null
  skillAndExperience: string | null
  preference: string | null
  lossAbility: string | null
  isID: boolean
  riskValue: number | null
  isRiskValue: boolean
  isRiskValueSec: boolean
  horizonteValue: number | null
  isHorizonteValue: boolean
  isHorizonteValueSec: boolean
  categorySec: string | null
  isCategorySec: boolean
  skillAndExperienceSec: string | null
  isSkillAndExperienceSec: boolean
  preferenceSec: string | null
  isPreferenceSec: boolean
  lossAbilitySec: string | null
  isLossAbilitySec: boolean
  orderComment: string | null
  internalComment: string | null
  shouldHaveKcUser: boolean
  shouldResetPassword: boolean
  activeKcUser: boolean
  createdKcUser: boolean
  clientExternalId: string | null
  feeBond: number | null
  feeEquity: number | null
  feeETF: number | null
  feeOption: number | null
  company: boolean
  companyName: string | null
  companyId: string | null
  companyAddress: Adress | null
  suitability: string | null
  clientPersons: ClientPerson[] | null
  salutation: string | null
  sex: string | null
}

export interface ClientPerson {
  clientPersonId: number
  person: Person | null
  type: string | null
}

export interface Person {
  persionId : number,
  businessTerritoryId: number,
  firstName: string,
  surname: string,
}

export interface MassOrderClient extends Client {
  massOrderByAmount: number | null
  massOrderByQuantity: number | null
  massOrderCurrency: string | null
  coverPercentage: number | null
  exchangedFromTo: boolean
  isCovered: boolean
  selectedPortfolio: ClientPortfolioType
}

export interface ClientRole {
  name: string
  roleId: number
  parentId: number
}

export interface ClientRolesList {
  roles: ClientRole[]
}

interface ClientState {
  clients: Client[]
  client: Client
  clientName: ClientName
  clientRoles: ClientRole[]
  clientPersons: ClientPerson[]
  clientAccountTotal: Number | null
  loading: boolean,
  clientDeals: ClientDeal[],
  clientCashflows: ClientCashflow[]
  clientTaxPosition: ClientTaxPosition | null
  clientTaxSummary: ClientTaxSummary | null
}

export interface ClientDeal {
  portfolio: String,
  kid: String,
  tradeDate: Date,
  tradeType: String,
  ticker: String,
  isin: String,
  depositary: String,
  price: number,
  quantity: number,
  fee: number,
  valueDate: Date,
  feeCurrency: String,
  amount: number,
  currency: String,
  firstName: String,
  surname: String,
  order: String,
  idTrade: number,
  tradeTypeDesc: String,
  product: String,
  number: String
}

export interface ClientCashflow {
  portfolio: String,
  kid: String,
  tradeDate: Date,
  paymentId: String,
  text: String,
  amount: number,
  valueDate: Date,
  currency: String,
  firstName: String,
  surname: String,
  number: String,
  sort: String,
  tpid: String
}

export interface ClientTaxPositionDeal {
  portfolio: String,
  kid: String,
  tradeDate: Date,
  tradeType: String,
  isin: String,
  ticker: String,
  depositary: String,
  quantity: number,
  quantityFill: number,
  fee: number,
  valueDate: Date,
  feeCurrency: String,
  amount: number,  
  currency: String,
  firstName: String,
  surname: String,
  order: String,
  idTrade: number,
  tradeTypeDesc: String,
  product: String,
  number: String,
  freeTax: Boolean
}

export interface ClientTaxPositionDealTmp{
  buy: ClientTaxPositionDeal,
  sells: ClientTaxPositionDeal[],
  profitLoss: number
}

export interface ClientTaxPosition {
  deals: ClientTaxPositionDealTmp[]
  withholdingTaxes: ClientCashflow[]
  otherOperations: ClientCashflow[]
}

export interface ProfitLossDeal {
  currency: String
  revenue: number
  cost: number
  profitLoss: number
}

export interface CurrencyAmount {
  currency: String
  amount: number
}

export interface ClientTaxSummary {
  deals: ProfitLossDeal[]
  dealsNoTax: ProfitLossDeal[]
  coupons: CurrencyAmount[]
  couponsNoTax: CurrencyAmount[]
  dividends: CurrencyAmount[]
  dividendsNoTax: CurrencyAmount[]
}

export interface ClientName {
  name: string
  valid: boolean
}

export const requiredClientAttributes = [
  'firstName',
  'surname',
  'personalNumber',
  'identityCardNumber',
  'telephoneNumber',
  'street',
  'town',
  'zipCode',
  'country',
  'roles',
  'feeBond',
  'feeETF',
  'suitability',
]

export const requiredClientCompanyAttributes = [
  'street',
  'town',
  'zipCode',
  'country',
  'Name',
  'Id',
]

const INITIAL_STATE = {
  clients: [],
  client: emptyClient,
  clientName: {name:'', valid:false},
  clientRoles: [],
  clientPersons: [],
  clientAccountTotal: null,
  loading: false,
  clientDeals: [],
  clientCashflows: [],
  clientTaxPosition: null,
  clientTaxSummary: null
}

export const clients = (state: ClientState = INITIAL_STATE, action: ReduxAction) => {
  switch (action.type) {
    case GET_CLIENTS_BEFORE:
      return {
        ...state,
        loading: true,
      }
    case GET_CLIENTS_AFTER:
      return {
        ...state,
        loading: false,
      }
    case GET_CLIENTS:
      return {
        ...state,
        clients: action.payload as Client[],
      }
    case GET_CLIENT:
      return {
        ...state,
        client: action.payload as Client,
      }
    case ADD_CLIENT:
      return {
        ...state,
        clients: [...state.clients, action.payload as Client],
      }
    case UPDATE_CLIENT:
      return {
        ...state,
        clients: [...state.clients.filter(c => c.clientId !== action.payload.clientId), action.payload],
        client: action.payload,
      }
    case VALID_CLIENT:
      return {
        ...state,
        clientName: action.payload as ClientName,
      }
    case CLEAR_VALID_CLIENT:
      return {
        ...state,
        clientName: {name:'', valid:false},
      }
    case GET_CLIENT_ROLES:
      return {
        ...state,
        clientRoles: action.payload as ClientRole[],
      }
    case GET_CLIENT_PERSON:
      return {
        ...state,
        clientPersons: action.payload as ClientPerson[],
      }
    case GET_CLIENT_ACCOUNT_TOTAL:
      return {
        ...state,
        clientAccountTotal: action.payload as Number,
      }
    case GET_CLIENT_DEALS:
    case GET_CLIENT_DEALS_ERROR:
        return {
        ...state, 
        clientDeals: action.payload as ClientDeal[],
      }
    case GET_CLIENT_CASHFLOWS:
    case GET_CLIENT_CASHFLOWS_ERROR:
        return {
        ...state,
        clientCashflows: action.payload as ClientCashflow[],
      }
    case GET_CLIENT_TAX_POSITION:
    case GET_CLIENT_TAX_POSITION_ERROR:
      return {
        ...state,
        clientTaxPosition: action.payload as ClientTaxPosition,
      }
    case GET_CLIENT_TAX_SUMMARY:
    case GET_CLIENT_TAX_SUMMARY_ERROR:
      return {
        ...state,
        clientTaxSummary: action.payload as ClientTaxSummary,
      }
    case GET_POSITION_BUYS:
      if ( state.client && state.client.portfolios ) {
        let tmp = [...state.client.portfolios];
        for ( let i=0; i<tmp.length; i++) {
          if ( !tmp[i].buys) {
            tmp[i].buys = [];
            tmp[i].buys.push({positionId: action.payload.id, buys: action.payload.buys})
          } else {
            for ( let j=0; j<tmp[i].buys.length; j++ ) {
              if ( tmp[i].buys[j].positionId==action.payload.id ) {
                tmp[i].buys[j] = {positionId: action.payload.id, buys: action.payload.buys};
              }
            }
            tmp[i].buys.push({positionId: action.payload.id, buys: action.payload.buys})
          }
        }
        return {
          ...state,
          client: {...state.client, portfolios: tmp}
        }
      }
      return {
        ...state, 
      }

    default:
      return state
  }
}
